import type IMassImportLocationsMessages from '.';

const messages: IMassImportLocationsMessages = {
	successToastTitle: 'Success!',
	successToastBody:
		'Mass Upload initiated. A report will appear on the Reports page when the mass upload is complete.',
	errorToastTitle: 'Error Uploading File',
	errorToastBody:
		'Something went wrong with the file transfer. Please re-upload the file.',
	formHeader: 'Mass Upload',
	uploadButton: 'Upload',
	downloadTemplate: 'Download Template',
	requestInProgress:
		'A mass upload is already in progress for this customer. Its progress can be viewed on the Reports tab.',
};

export default messages;
